import { useEffect } from 'react';
import type { ResolveDisputeContext } from '@scale/genai-compass-shared/cards/resolve_dispute';
import { useCompassCard } from '@scale/compass-ui/store';
import { DisputeDecision } from '@scale/shared/types/chat/disputes';
import _ from 'lodash';

const useResolveDisputesCard = (index: number) => {
  const { card, updateCardContext, updateCardCanSubmit } =
    useCompassCard<ResolveDisputeContext>(index);
  const { retrievedOutput } = useCompassCard(index - 1);
  const context = card.defaultContext;

  const columns = retrievedOutput?.response?.schema || [];

  const setResolution = (resolution: DisputeDecision | null) => {
    updateCardContext({ ...context, resolution: resolution || DisputeDecision.ACCEPTED });
  };

  const setSelectedDisputeColumn = (selectedDisputeColumn: string) => {
    updateCardContext({
      ...context,
      selectedDisputeColumn,
    } as ResolveDisputeContext);
  };

  useEffect(() => {
    const isValid = !!context.resolution;
    updateCardCanSubmit(isValid);
  }, [context.resolution]);

  const hasError = _.isNil(context.resolution);

  return {
    resolution: context.resolution || null,
    setResolution,
    selectedDisputeColumn: context.selectedDisputeColumn,
    setSelectedDisputeColumn,
    columns,
    hasError,
  };
};

export default useResolveDisputesCard;
